import React, { createContext, useState, useContext, useEffect } from 'react';
import { accountApi } from '../api/account';
import { AuthService } from '../services/AuthService';

// Create AuthContext
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(null); 
    const [loading, setLoading] = useState(true); 
    
    useEffect(() => {
        checkAuthStatus();
    }, []);

    const checkAuthStatus = async () => {
        try {
            
            const userData = await accountApi.me();
            
            if (userData) {
                setUser(userData.data);
                setIsAuthenticated(true);
            } else {
                setIsAuthenticated(false);
                setUser(null);
            }
        } catch (error) {
            // Check for various unauthorized error formats
            const isUnauthorized = 
                error.message.includes('401') || 
                error.message.includes('Unauthorized') ||
                (error.error && error.error.code === 'UNAUTHORIZED') ||
                (error.error && error.error.message === 'Unauthorized');
            
            if (isUnauthorized) {
                // Clear session when unauthorized
                AuthService.clearSession();
            } else {
            }
            setIsAuthenticated(false);
            setUser(null);
        } finally {
            setLoading(false);
        }
    };

    // Logout function
    const logout = async () => {
        try {
            await accountApi.logout();
        } catch (error) {
        } finally {
            setUser(null);
            setIsAuthenticated(false);
        }
    };

    const login = () => {
        setIsAuthenticated(true);
        // Re-check auth status to get user data
        checkAuthStatus();
    };

    // Only render children if loading is false (after the auth check)
    if (loading) {
        return <div>Loading...</div>; // Show a loading spinner while checking authentication
    }

    return (
        <AuthContext.Provider value={{ isAuthenticated, user, logout, login, checkAuthStatus }}>
            {children}
        </AuthContext.Provider>
    );
};

// Custom hook to use AuthContext
export const useAuth = () => useContext(AuthContext);
